import { DURATION, EASE, useReducedMotion } from '@/lib/motion-presets';
import { cn } from '@/lib/utils';
import { motion } from 'motion/react';
import type { ReactNode } from 'react';

interface FadeInProps {
	children: ReactNode;
	delay?: number;
	className?: string;
}

export default function FadeIn({ children, delay = 0, className }: FadeInProps) {
	const reducedMotion = useReducedMotion();

	if (reducedMotion) {
		return <div className={cn(className)}>{children}</div>;
	}

	return (
		<motion.div
			className={cn(className)}
			initial={{ opacity: 0, y: 6 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: DURATION, delay, ease: EASE }}
		>
			{children}
		</motion.div>
	);
}
